import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    IconButton,
} from "@mui/material";
import React from "react";
import {HighlightOff} from "@mui/icons-material";
import EnhancedTextField from "../../../../../../components/EnhancedTextField";
import { DialogHeader } from "../../../../../../theme";

// region TypeScript Interfaces
interface SaveAsState {
    newProfileName: string;
    disabled?: boolean;
    [key: string]: unknown;
}

interface EnhancedSaveAsDialogProps {
    open: boolean;
    onClose: () => void;
    saveAs: () => void;
    setState: (patch: Partial<SaveAsState>) => void;
    state: SaveAsState;
}
// endregion

export default function EnhancedSaveAsDialog(props: EnhancedSaveAsDialogProps) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const {open, onClose, saveAs, setState} = props; // These vars are used

    return (
        <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth={true}
                slotProps={{
                    paper: {
                        style: {
                            borderRadius: "12px"
                        }
                    }
                }}
        >
            <DialogTitle>
                <Grid item container justifyContent={"space-between"} alignItems={"center"}>
                    <Grid item container style={{flex: 0.5, flexDirection: "column"}}>
                        <DialogHeader>
                            Save Profile As
                        </DialogHeader>
                    </Grid>

                    <IconButton onClick={() => props.onClose()} size="large">
                        <HighlightOff style={{color: "red"}}/>
                    </IconButton>
                </Grid>
            </DialogTitle>
            <DialogContent>
                <EnhancedTextField
                    placeholder={"Enter a name for the new profile"}
                    value={props.state.newProfileName}
                    onChange={e => props.setState({newProfileName: e.target.value})}
                />
            </DialogContent>
            <DialogActions style={{padding: "24px"}}>
                <Button variant="text" disabled={props.state.disabled} onClick={onClose}>Cancel</Button>
                <Button variant="text" color="primary" disabled={!props.state.newProfileName || props.state.disabled} onClick={() => props.saveAs()}>Save</Button>
            </DialogActions>
        </Dialog>
    );
}
